export enum UserRole {
  Admin = 'admin',
  Contributor = 'contributor',
  Owner = 'owner',
  WixStaff = 'wixStaff',
}
